/** @format */
import { css } from 'styled-components';

import { BadgeColour, BadgeProps, BadgeSize } from './index';

/**
 * Base styles for the badge component
 */
/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = css`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    padding: 0 0.2rem;
    transition:
        min-width 0.3s linear,
        height 0.3s linear,
        font-size 0.3s linear;
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

/**
 * Size styles for the badge component
 *
 * @param {BadgeProps} props The badge properties object
 * @param {string} props.size The badge size
 * */
const sizeStyles = ({ size }: BadgeProps) => {
    switch (size) {
        case BadgeSize.REGULAR:
            /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
            return css`
                font-size: 1.2rem;
                min-width: 2.4rem;
                height: 2.4rem;
                border-radius: 1.2rem;

                .badge-text-container {
                    margin-top: -0.2rem;
                }
            `;
        /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

        case BadgeSize.LARGE:
            /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
            return css`
                font-size: 1.6rem;
                min-width: 3.6rem;
                height: 3.6rem;
                border-radius: 1.8rem;

                .badge-text-container {
                    margin-top: -0.2rem;
                }
            `;
        /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

        case BadgeSize.XL:
            /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
            return css`
                font-size: 2.4rem;
                min-width: 4.8rem;
                height: 4.8rem;
                padding: 0 1.2rem;
                border-radius: 2.4rem;

                .badge-text-container {
                    margin-top: -0.2rem;
                }
            `;
        /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

        case BadgeSize.SMALL:
        default:
            /* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
            return css`
                font-size: 0.8rem;
                min-width: 1.6rem;
                height: 1.6rem;
                border-radius: 0.8rem;

                .badge-text-container {
                    margin-top: -0.1rem;
                }
            `;
        /* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
    }
};

/**
 * Colour styles for the badge component
 *
 * @param {BadgeProps} props The badge properties object
 * @param {string} props.colour The badge colour
 * */
const colourStyles = ({ colour }: BadgeProps) => {
    switch (colour) {
        case BadgeColour.MIDNIGHT:
            return css`
                color: var(--colors-text-inverse);
                background: var(--colors-surface-inverse);
            `;

        case BadgeColour.WHITE:
            return css`
                color: var(--colors-text-secondary);
                background: var(--colors-surface-primary);
            `;

        case BadgeColour.SOL:
            return css`
                color: var(--colors-text-secondary);
                background: var(--colors-surface-accent);
            `;

        case BadgeColour.FLAME:
        default:
            return css`
                color: var(--colors-text-inverse);
                background: var(--colors-surface-accent-inverse);
            `;
    }
};

/**
 * The badge component styles
 *
 * @param {BadgeProps} props The badge properties object
 * */
export const styles = (props: BadgeProps) => css`
    ${baseStyles}
    ${sizeStyles(props)}
    ${colourStyles(props)}
`;
